import React from 'react'
import { withRouter } from 'react-router-dom'
import { Container, Header, Wrapper } from '../../components_renew/Layout'
import xiniu_eventsBg0 from '../../assets/xiniu/fee_off/bg_0.jpg'
import xiniu_eventsBg1 from '../../assets/xiniu/fee_off/bg_1.jpg'
import xiniu_eventsBg2 from '../../assets/xiniu/fee_off/bg_2.jpg'
import xiniu_cardImg0 from '../../assets/xiniu/fee_off/card_0.png'
import xiniu_cardImg1 from '../../assets/xiniu/fee_off/card_1.png'
import xiniu_btnImg from '../../assets/xiniu/fee_off/btn_0.png'
import qxtj_eventsBg0 from '../../assets/qxtj/fee_off/bg_0.jpg'
import qxtj_eventsBg1 from '../../assets/qxtj/fee_off/bg_1.jpg'
import qxtj_eventsBg2 from '../../assets/qxtj/fee_off/bg_2.jpg'
import qxtj_cardImg0 from '../../assets/qxtj/fee_off/card_0.png'
import qxtj_cardImg1 from '../../assets/qxtj/fee_off/card_1.png'
import qxtj_btnImg from '../../assets/qxtj/fee_off/btn_0.png'
import haiou_eventsBg0 from '../../assets/haiou/fee_off/bg_0.jpg'
import haiou_eventsBg1 from '../../assets/haiou/fee_off/bg_1.jpg'
import haiou_eventsBg2 from '../../assets/haiou/fee_off/bg_2.jpg'
import haiou_cardImg0 from '../../assets/haiou/fee_off/card_0.png'
import haiou_cardImg1 from '../../assets/haiou/fee_off/card_1.png'
import haiou_btnImg from '../../assets/haiou/fee_off/btn_0.png'
import { handleCatch, postMessage } from '../../utils'

const assets = {
  bg0: '',
  bg1: '',
  bg2: '',
  card0: '',
  card1: '',
  btn0: ''
}

switch (process.env['REACT_APP_CHANNEL']) {
  case 'haiou':
    assets.bg0 = haiou_eventsBg0
    assets.bg1 = haiou_eventsBg1
    assets.bg2 = haiou_eventsBg2
    assets.card0 = haiou_cardImg0
    assets.card1 = haiou_cardImg1
    assets.btn0 = haiou_btnImg
    break
  case 'youpin':
  case 'xbyg':
  case 'xibei':
  case 'xiniu':
    assets.bg0 = xiniu_eventsBg0
    assets.bg1 = xiniu_eventsBg1
    assets.bg2 = xiniu_eventsBg2
    assets.card0 = xiniu_cardImg0
    assets.card1 = xiniu_cardImg1
    assets.btn0 = xiniu_btnImg
    break
  // case 'tradeasy':
  // case 'tjyg':
  //   break
  // case 'qxtj':
  // case 'qxyg':
  // case 'qxdg':
  // case 'tjyg':
  //   break
  // case 'ytyg':
  // case 'dyyg':
  default:
    assets.bg0 = qxtj_eventsBg0
    assets.bg1 = qxtj_eventsBg1
    assets.bg2 = qxtj_eventsBg2
    assets.card0 = qxtj_cardImg0
    assets.card1 = qxtj_cardImg1
    assets.btn0 = qxtj_btnImg
}

@withRouter
class FeeOff extends React.PureComponent {
  state = {
    data: 0,
    integral: 0,
    success: false,
  }

  componentDidMount () {
    document.title = '全民免手续费'
    window.toast.loading()
    window.axios.request({
      method: 'POST',
      url: window.API.User.postFeeToday
    })
      .then(res => {
        window.toast.hide()
        this.setState({ success: true })
        if (res > 0) {
          let integral = res * 10
          if (integral > 1000) integral = 1000
          this.setState({
            data: res,
            integral
          })
        }
      }).catch(handleCatch)
  }

  render () {
    const { withHeader } = this.props
    const { success, data, integral } = this.state
    return <Container>
      {withHeader ? <Header>活动</Header> : null}
      <Wrapper className={'m-fo__wrapper'}>
        <img className={'m-fo__bg'} src={assets.bg0} alt=""/>
        <div className={'m-fo__box'}>
          {
            success ?
              (data > 0) ?
                <div className={'m-fo__info'} style={process.env['REACT_APP_CHANNEL'] !== 'haiou' && { top: '6rem' }}>
                  <div className={'m-fo__info__sub'}>今日可领</div>
                  <div className={'m-fo__info__text'}>{integral}
                    <span className={'m-fo__info__span'}>积分</span>
                  </div>
                </div>
                : <div className={'m-fo__info'} style={process.env['REACT_APP_CHANNEL'] !== 'haiou' && { top: '6rem' }}>
                  <div className={'m-fo__info__sub'}>今日最高可领</div>
                  <div className={'m-fo__info__text'}>100
                    <span className={'m-fo__info__span'}>元</span>
                  </div>
                </div>
              : null
          }
          <img className={'m-fo__card'} src={assets.card0} alt=""/>
          <div className={'m-fo__btn'}>
            <img className={'m-fo__btn__img'} src={assets.btn0} onClick={this.onClick} alt=""/>
            {data > 0 ?
              <div className={'m-fo__btn__label'}>今日服务费： {data} 元</div>
              : <div className={'m-fo__btn__label'}>现金订购即可参与活动</div>}
          </div>
          <img className={'m-fo__card'} src={assets.card1} alt=""/>
        </div>
        <img className={'m-fo__bg'} src={assets.bg1} alt=""/>
        <img className={'m-fo__bg'} src={assets.bg2} alt=""/>
      </Wrapper>
    </Container>
  }

  onClick = () => {
    postMessage({
      type: window.POST_TYPE.BUY
    })
  }
}

export default FeeOff
